import request from './request'

function uploadAuth(options = {}) {
  return { useAdminAuth: options.useAdmin === true }
}

async function uploadViaServer(file, bizType, options = {}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('bizType', bizType)
  return request.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000,
    ...uploadAuth(options)
  })
}

export async function uploadFile(file, bizType = 'common', options = {}) {
  const auth = uploadAuth(options)
  const ticket = await request.post('/upload/prepare', {
    fileName: file.name,
    contentType: file.type || 'application/octet-stream',
    fileSize: file.size,
    bizType
  }, auth)

  if (!ticket || !ticket.direct) {
    if (file.size > 20 * 1024 * 1024) {
      throw new Error('对象存储直传未开启，无法上传超过 20MB 的文件')
    }
    return uploadViaServer(file, bizType, options)
  }

  const putRes = await fetch(ticket.uploadUrl, {
    method: ticket.method || 'PUT',
    headers: ticket.headers || {},
    body: file
  })
  if (!putRes.ok) {
    throw new Error('直传失败 HTTP ' + putRes.status)
  }

  return request.post('/upload/complete', {
    fileKey: ticket.fileKey,
    fileName: file.name,
    contentType: file.type || 'application/octet-stream',
    fileSize: file.size,
    bizType
  }, auth)
}
